import { render, staticRenderFns } from "./footer.html?vue&type=template&id=a2d3fb3e&scoped=true&"
import script from "./footer.js?vue&type=script&lang=js&"
export * from "./footer.js?vue&type=script&lang=js&"
import style0 from "./footer.css?vue&type=style&index=0&id=a2d3fb3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d3fb3e",
  null
  
)

export default component.exports